import { dateToTimeZone } from './dateToTimeZone';

export const checkIsFuture = (dateForCheck: Date, timeZone: string) => {
  const currentDate = dateToTimeZone(new Date(), timeZone);
  const currentTimestamp = currentDate.getTime();
  const dateTimestamp = dateForCheck.getTime();
  return dateTimestamp > currentTimestamp;
};
